//  fetchPoolBalances
export const NFT_FETCH_POOL_BALANCES_BEGIN = 'NFT_FETCH_POOL_BALANCES_BEGIN';
export const NFT_FETCH_POOL_BALANCES_SUCCESS = 'NFT_FETCH_POOL_BALANCES_SUCCESS';
export const NFT_FETCH_POOL_BALANCES_FAILURE = 'NFT_FETCH_POOL_BALANCES_FAILURE';


